var _rect, _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterlayLogoWithText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 30,
    viewBox: "0 0 157 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 30,
    rx: 4,
    fill: "#1a0a2d"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 11L8 8H19.5L24 11H13Z",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15,
    r: 2,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 22L8 19H19.5L24 22H13Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 8.76296H46.1932V21.237H43V8.76296Z",
    fill: "#19053B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6462 8.76296H56.2411L61.2595 17.1373H61.2787L61.1825 8.76296H64.1801V21.237H60.4095L54.5876 11.5612H54.5684L54.6453 21.2246H51.6462V8.76296Z",
    fill: "#19053B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6595 11.2069H69.0188V8.76296H79.4741V11.2069H75.8543V21.237H72.6595V11.2069Z",
    fill: "#19053B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3064 8.76296H93.3792V11.2069H87.4996V14.016H92.0529V15.9106H87.4996V18.79H93.5556V21.237H84.3064V8.76296Z",
    fill: "#19053B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4842 8.76296H104.462C107.851 8.76296 109.68 10.1269 109.68 12.4757C109.68 14.0675 108.98 15.0726 107.772 15.4128V15.4502C109.037 15.7343 109.602 16.7206 109.602 18.122V21.237H106.409V18.225C106.409 17.0889 105.98 16.5957 104.773 16.5957H101.676V21.237H98.4842V8.76296ZM104.598 14.7121C105.942 14.7121 106.624 14.1253 106.624 12.9688C106.624 11.8764 105.923 11.2069 104.442 11.2069H101.676V14.7121H104.598Z",
    fill: "#19053B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.939 8.76296H118.133V18.7853H123.969V21.237H114.939V8.76296Z",
    fill: "#19053B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.547 18.6901H132.427L131.55 21.237H128.278L133.226 8.77077H137.197L142.142 21.237H138.424L137.547 18.6901ZM136.886 16.758L134.997 11.2959H134.958L133.088 16.758H136.886Z",
    fill: "#19053B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148.143 16.4553L143.101 8.76296H147.208L150.012 13.6883H150.069L152.838 8.76296H156.4L151.338 16.4553V21.237H148.145L148.143 16.4553Z",
    fill: "#19053B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterlayLogoWithText);
export default __webpack_public_path__ + "static/media/interlay-logo-with-text.2036678e.svg";
export { ForwardRef as ReactComponent };